/**
 * PermissionPicker — grade multi-select dos 8 BOND_PERMISSION_KEYS (ADR-082).
 * Espelha o ScopePicker do B1 (chips), mas sem agrupar (só 8 chaves).
 * Reutilizado pelos formulários de adicionar e editar participante.
 */

import { BOND_PERMISSION_KEYS } from '@lume/shared';

import { permissionLabel } from './participants-labels';

interface PermissionPickerProps {
  selected: string[];
  onToggle: (key: string) => void;
  idPrefix: string;
}

export function PermissionPicker({
  selected,
  onToggle,
  idPrefix,
}: PermissionPickerProps): JSX.Element {
  return (
    <div className="bpt-perms">
      {BOND_PERMISSION_KEYS.map((key) => {
        const id = `${idPrefix}-${key}`;
        const checked = selected.includes(key);
        return (
          <label key={key} htmlFor={id} className={`bpt-chip${checked ? ' bpt-chip--on' : ''}`}>
            <input
              id={id}
              type="checkbox"
              className="bpt-chip__input"
              checked={checked}
              onChange={() => onToggle(key)}
            />
            <span>{permissionLabel(key)}</span>
          </label>
        );
      })}
    </div>
  );
}
